import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const getNationalCoach = async () => {
    return axios.get(`${BACKEND_URL}/nationalCoach`);
};

export const updateSquad = async (email, squad) => {
    return axios.put(`${BACKEND_URL}/athletes/${email}/squad`, squad);
};